// extracted by mini-css-extract-plugin
module.exports = {"card":"Promotions_card__878fi","promoContainer":"Promotions_promoContainer__1_aR8"};